import React from 'react';
import { Overlay, Box, FullLogo, IconButton } from '@kistech/kis-ui';
import { selectors as adminsSelectors, actions as adminsActions } from 'store/admins';
import { useSelector } from 'react-redux';
import { CreateNewUserOverlayProps } from '../types';
import { CreateNewUserForm } from './CreateNewUserForm';
import { CreateNewUserSuccess } from './CreateNewUserSuccess';
import { useActions } from 'hooks/useActions';
import { Grid, Box as MuiBox, Container } from '@mui/material';
import { useStyles } from '../styled';

export const CreateNewUserOverlay = (props: CreateNewUserOverlayProps) => {
  const { onCancel, onConfirm } = props;

  // ACTION CREATORS AND SELECTORS
  const { resetAction } = useActions({
    resetAction: adminsActions.resetAction
  });
  const { successful } = useSelector(adminsSelectors.selectAction);
  const classes = useStyles();

  // CANCEL CLICK
  const onCancelClick = () => {
    // IF ACTION SUCCESSFUL - RESET ACTION
    if (successful) resetAction();
    // PROPS.ONCANCEL
    onCancel();
  };

  return (
    <Overlay>
      <Box bg="x-light-gray" height="100vh" width="100%" overflow="auto">
        <Container className={classes.createNewUserContainer}>
          <Box bg="white" style={{ borderRadius: '32px 32px 0 0' }}>
            {/* OVERLAY HEADER */}
            <Grid className={classes.createNewUserLogoBlock}>
              <MuiBox className={classes.createNewUserLogo}>
                <FullLogo />
              </MuiBox>
              <MuiBox className={classes.createNewUserCloseIcon}>
                <IconButton
                  data-testid="create-new-user-x"
                  name="exit_circle"
                  onClick={onCancelClick}
                  appearance="transparent"
                  size={40}
                />
              </MuiBox>
            </Grid>
            {/* IF ACTION SUCCESSFUL - SHOW CREATENEWUSERSUCCESS COMPONENT ELSE SHOW CREATENEWUSERFORM COMPONENT */}
            {successful ? <CreateNewUserSuccess onConfirm={onConfirm} /> : <CreateNewUserForm />}
          </Box>
        </Container>
      </Box>
    </Overlay>
  );
};
